import crackYellowTemp from "assets/crack-yellow-temp.svg";
import crackDrop from "assets/crack-drop.svg";
import crackPlug from "assets/crack-plug.svg";
import fastWind from "assets/fast-wind.svg";

export const rows =  
[
    {
        "id": "RAW-A",
        "label": "Row A",
        "blocks": [
            { "id": "RPP", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25%",
                      type: "Air Flow",
                      color: "#FF5233",
                      icon: fastWind,
                    },
                    {
                      id: "25%",
                      type: "Air Percentage",
                      color: "#FF5233",
                      icon: fastWind,
                    },
                  ],
             },
            { "id": "RPP", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                        id: "25.2KW",
                        type: "Power Consumption",
                        color: "#FF5233",
                        icon: crackPlug,
                      },
                    {
                        id: "25.2KW",
                        type: "White Space",
                        color: "#FF5233",
                        icon: crackPlug,
                      },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            { "id": "RPP", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            {
                "id": "2520000461", "status": "used", "color": "#fff",
                blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#fff",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },

            {
                "id": "2520000461", "status": "used", "color": "#fff",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },

            {
                "id": "2520000461", "status": "free", "color": "#FF5233",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            { "id": "2520000461", "status": "used", "color": "#fff",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            {
                "id": "2520000461", "status": "free", "color": "#FF5233",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
             },
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            }

        ]
    },
    {
        "id": "RAW-B",
        "label": "Row B",
        "blocks": [
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                        id: "50%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                      {
                        id: "25%",
                        type: "Air Flow",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                      {
                        id: "25%",
                        type: "Air Percentage",
                        color: "#FF5233",
                        icon: fastWind,
                      },
                         
                  ],
            },
            { "id": "RPP", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "RPP", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "RPP", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
             {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#fff",
                blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            },
            {
                "id": "2520000461", "status": "used", "color": "#fff",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            },

            {
                "id": "2520000461", "status": "used", "color": "#fff",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            },
           

            {
                "id": "2520000461", "status": "free", "color": "#FF5233",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            },
            { "id": "2520000461", "status": "used", "color": "#fff",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            {
                "id": "2520000461", "status": "free", "color": "#FF5233",
                      blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
            { "id": "2520000461", "status": "used", "color": "#fff",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
             },
         
            {
                "id": "2520000461", "status": "used", "color": "#FDBD4D",
                         blocks: [
                    {
                      id: "29.1C",
                      type: "Temperature",
                      color: "#FDBD4D",
                      icon: crackYellowTemp,
                    },
                    {
                      id: "30%",
                      type: "Humidity",
                      color: "#fff",
                      icon: crackDrop,
                    },
                    {
                      id: "25.2KW",
                      type: "Power Consumption",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                    {
                      id: "25.2KW",
                      type: "White Space",
                      color: "#FF5233",
                      icon: crackPlug,
                    },
                       {
                            id: "50%",
                            type: "Air Percentage",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                          {
                            id: "25%",
                            type: "Air Flow",
                            color: "#FF5233",
                            icon: fastWind,
                          },
                  ],
            }

        ]
    }
];